import { render } from "./HeroiconsOutlineLockOpen.vue?vue&type=template&id=bc2a5a72"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLockOpen.vue"]])

export default __exports__